import React from 'react';
import { MenuItem } from '../menu';
import { executeCallbacks } from '~/utils';
import { useDropdownContext } from './dropdown-context';
const componentId = 'vulcanui-dropdown-item';
function DropdownItem(props) {
    const { value, children, onClick, disabled } = props;
    const { onSelect } = useDropdownContext('DropdownItem');
    const clickHandler = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (disabled)
            return;
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(value);
    };
    return (React.createElement(MenuItem, { disabled: disabled, onClick: executeCallbacks(onClick, clickHandler) }, children));
}
DropdownItem.displayName = 'Dropdown.Item';
DropdownItem.toString = () => `.${componentId}`;
export default DropdownItem;
//# sourceMappingURL=dropdown-item.js.map